module.exports = __webpack_public_path__ + "static/media/IconTemplates_-26.340f2efb.svg";